const selectors = {
    CONTENT: '.js-card-content',
    EDIT_LINK: '.js-chairish-card-edit',
    SUMMARY: '.js-chairish-card-summary',
};

/**
 * Simple card component that toggles between editable and collapsed states.
 *
 * @param {jQuery} $el The card's jQuery element
 */
class CardComponent {
    constructor($el) {
        this.$el = $el;
    }

    toggleSelectorsHidden(selectorsToHide) {
        const selectorsToShow = Object.values(selectors).filter((selector) => !selectorsToHide.includes(selector));

        selectorsToHide.forEach((selector) => {
            this.$el.find(selector).addClass('hidden');
        });
        selectorsToShow.forEach((selector) => {
            this.$el.find(selector).removeClass('hidden');
        });
    }

    /**
     * Toggles content that should only be shown while the card is editable.
     *
     * @param {boolean} shouldShow
     */
    toggleEditOnlyContent(shouldShow) {
        this.$el.find('.js-edit-only').toggleClass('hidden', !shouldShow);
    }

    /**
     * Hides everything except for card's title.
     */
    collapse() {
        this.toggleSelectorsHidden(Object.values(selectors));
        this.$el.addClass('is-collapsed');
        this.$el.removeClass('is-selected');
        this.toggleEditOnlyContent(false);
    }

    /**
     * Puts the card in an editable state by showing its form elements.
     */
    edit() {
        this.toggleSelectorsHidden([selectors.SUMMARY, selectors.EDIT_LINK]);
        this.$el.removeClass('is-collapsed');
        this.$el.addClass('is-selected');
        this.toggleEditOnlyContent(true);
    }

    /**
     * Show the card's summary.
     */
    summarize() {
        this.toggleSelectorsHidden([selectors.CONTENT]);
        this.$el.removeClass('is-collapsed is-selected');
        this.toggleEditOnlyContent(false);
    }
}

export default CardComponent;
